import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure';
import { environment } from 'environments/environment';

@Injectable()
export class AggregatorEligabilityService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    miwEligibility = (data): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}Eligablility/MiwEligibility`, JSON.stringify(data))
    }

    miwEligibilites = (data): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}Eligablility/MiwEligibilities`, JSON.stringify(data))
    }
}
